<template>
  <svg viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.9229 20.4557V11.565H18.252C16.0397 11.565 15.0679 11.6478 13.4966 11.8752L13.3312 11.3583C14.7785 10.6553 15.4608 10.3245 16.598 9.68353L17.301 9.29069V0.027832L0.0778323 15.2661V16.6927L17.301 31.9723V22.7508L16.598 22.3579C15.4608 21.717 14.7785 21.3655 13.3312 20.6832L13.4966 20.1663C15.0679 20.3937 16.0397 20.4557 18.252 20.4557H25.9229Z"
      fill="currentColor"
    />
  </svg>
</template>
